















import { isString } from 'lodash-es';
import { defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
props: {
    node: {
        type: Object,
        required: true
    }
},
setup(props) {
    const { node: content } = props;
    const selectedIndex = ref(null);
    const paddingClasses = ref([])
    if(content.cssClasses.includes('autori-block') && content.children.length==1){
        selectedIndex.value=0;
    }else{
        paddingClasses.value = ['px-3','md:px-5']

    }
    return {
        content,
        selectedIndex,
        paddingClasses
    };
},
computed: {
},
methods:{
    keyDown(e, index) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.selectedIndex = index;
        }
    },
    renderHTML(content) {
        if (process.server) {
            //@ts-ignore
            return isString(content) ? content : content.outerHTML;  
        }

        //@ts-ignore
        return content;
    }
}
})
